(function modal($, Drupal) {
  /* eslint-disable */
  
  // Check if the page hass .img-responsive class 
  if ($(".img-responsive")[0]){
    
    // Create lightbox well.
    const lightbox = `
      <div class="lightbox">
      <div class="lightbox__container">
        
        <div class="lightbox__header">
          <div id="lightbox--close" class="lightbox__close"><i class="fas fa-times"></i><span>Close</span></div>
        </div>

        <div class="lightbox__body" data-lightbox="">
          <img id="lightbox--img" src="" alt="">
          <div id="lightbox--caption" class="caption"></div>
        </div>

      </div>
    </div>
  `;

  // Append to body
  $('body').append(lightbox);

  // On click load high res url and show box.
  $('.modal__target .img-responsive, .article__hero .img-responsive, .wyswyg-edit .img-responsive, .wyswyg-edit .lazyloaded, .resource-overview .img-responsive, .species-right-image .img-responsive').on('click', function() {

    // Reset lightbox src
    $('#lightbox--img').attr('src', '');
    $('#lightbox--caption').text('');

    // Logic to get high res image.
    const regex = /styles.*\/s3\//;
    let originalImgSrc = $(this).attr('src');
    let highResImg = originalImgSrc.replace(regex, '');

    // Get caption
    let caption;
    if($(this).next().attr('class') == 'dam_caption') {
      caption = $(this).next().text();
    } else {

      // Here we need to check it the next item for WYSIWYG is a figcaption.
      if ($(this).closest('.embedded-entity').next().is('figcaption')) {
        caption = $(this).closest('.embedded-entity').next().text(); // WYSWYG caption
      } else {
        caption = ''; // no value for caption.
      }
    }
    
    // Prepare lightbox
    $('#lightbox--img').attr('src', highResImg);
    $('#lightbox--caption').text(caption);
    $('.lightbox__body').css('display', 'block');

    // Only show when image
    var image = new Image();
    image.onload = function () {
      
      // Cap the width to 1400px
      if (image.width >= '1400') {
        $('.lightbox__container').css('max-width', '1400px');
      } else {
        $('.lightbox__container').css('max-width', image.width);
      }
      $('body').css('overflow', 'hidden');
      $('.lightbox').css('overflow', 'scroll');
      $('.lightbox').fadeIn();

    }

    image.src = highResImg;

  });

}

  /* eslint-enable */
}(jQuery, Drupal));

